/**
 * Forms a link for sharing with pre-selected category parameters.
 */

/**
 * Initializes the sharing link functionality.
 *
 * @function HandleSharingLink
 * @returns {void}
 */
const HandleSharingLink = () => {
  const button = document.querySelector('.js-sharing-button')
  const notification = createNotification()

  if (button) {
    button.addEventListener('click', function() {
      const url = formSharingLink()

      copyUrlToClipboard(url, button)
    })
  }
}

/**
 * Creates a reusable notification element, appends it to the document body,
 * and exposes it globally via the `window.copyNotification` property.
 *
 */
const createNotification = () => {
    const notification = document.createElement('div')
    notification.className = 'copy-notification'
    document.body.appendChild(notification)

    // Expose the notification element globally for our functions to use
    window.copyNotification = notification
}

/**
 * Generates a sharing link based on the current page's URL and specific parameters.
 *
 * @returns {string} The generated sharing link. If parameters are available, they are appended
 *                   as a query string. Otherwise, the base URL is returned.
 */
const formSharingLink = () => {
  let sharingLink = ''

  const baseUrl = window.location.origin + window.location.pathname
  const params = formCatParams()

  if (baseUrl && params) {
    sharingLink = `${baseUrl}?demo-hide=${params}`
  } else if (baseUrl) {
    sharingLink = baseUrl
  }

  return sharingLink
}

/**
 * Forms a query parameter string from unchecked checkboxes with the class 'js-marker-category'.
 *
 * This function selects all unchecked checkboxes with the class 'js-marker-category' and
 * concatenates their values into a single string, separated by an '&' character. The resulting
 * string can be used as query parameters for a URL.
 *
 * @returns {string} A string of concatenated values from unchecked checkboxes, separated by '&'.
 */
const formCatParams = () => {
  const uncheckedCheckboxes = document.querySelectorAll('.js-marker-category:not(:checked)')

  let linkParams = ''

  uncheckedCheckboxes.forEach((category, index) => {
    if (index === 0) {
      linkParams += category.value
    } else {
      linkParams += `&${category.value}`
    }
  })

  return linkParams
}

/**
 * Copies the provided URL to the clipboard and displays a temporary notification.
 *
 * @param {string} url - The URL to be copied to the clipboard.
 * @param {HTMLElement} linkElement - The HTML element under which the notification will be displayed.
 * @returns {void}
 */
const copyUrlToClipboard = (url, linkElement) => {
  navigator.clipboard.writeText(url)
    .then(() => {
      // Show notification under the link
      showTemporaryNotification('Link copied to clipboard!', linkElement)
    })
    .catch(err => {
      console.error('Failed to copy: ', err)
      showTemporaryNotification('Failed to copy link', linkElement)
    })
}

/**
 * Displays a temporary notification message near a specified element.
 *
 * @param {string} message - The message to display in the notification.
 * @param {HTMLElement} element - The HTML element near which the notification will be positioned.
 * @param {number} [duration=3000] - The duration (in milliseconds) for which the notification will be visible. Defaults to 3000ms.
 */
const showTemporaryNotification = (message, element, duration = 3000) => {
  const notification = window.copyNotification
  const elementRect = element.getBoundingClientRect()

  // Position the notification centered under the element
  const notificationWidth = notification.offsetWidth || 170 // Estimate if not yet rendered
  notification.style.left = `${elementRect.left + (elementRect.width/2) - (notificationWidth/2) + window.scrollX}px`
  notification.style.top = `${elementRect.bottom + window.scrollY + 10}px` // 10px gap

  // Set the message
  notification.textContent = message

  // Show the notification
  notification.style.display = 'block'

  // Hide the notification after the specified duration
  setTimeout(() => {
    notification.style.display = 'none'
  }, duration)
}

export default HandleSharingLink
